import { useCallback, useState } from 'react';
import Header from '../../components/Header/Header';
import StoryList from '../../components/StoryList/StoryList';
import ArticleList from '../../components/ArticleList/ArticleList';
import ExploreSidebar from '../../components/ExploreSidebar/ExploreSidebar';
import Switcher from '../../components/Switcher/Switcher';
import { useMyJaaqContext } from '../../core/context/MyJaaqContext';
import useScreenSize from '../../core/hooks/useScreenSize';
import {
  StyledPageContainer,
  StyledPageSidebar,
  StyledPageContent,
  StyledPageMainContent,
} from '../../styles/config/pageStyle';
import LikedQuestions from '../../components/LikedQuestions/LikedQuestions';
import Boards from '../../components/Boards/Boards';

function MyJaaq() {
  const [size] = useScreenSize();
  // TODO: Move this functionality to context insted of setting functionality in page component
  const [state, setState] = useState(true);

  const onSwitchClick = useCallback(value => {
    setState(value);
  });

  const {
    likedExperiences,
    likedHeading,
    recommendedExperiences,
    recommendedHeading,
    articles,
    exploreSidebar,
    boards,
    switcherButtons,
  } = useMyJaaqContext();

  // TODO: Delete block of code, from this:

  const experienceStorage = JSON.parse(localStorage.getItem('likedExperiences'));
  const likedItemsToShow = likedExperiences.filter(element =>
    experienceStorage.includes(element.experienceId)
  );
  const articleStorage = JSON.parse(localStorage.getItem('savedArticles'));
  const likedArticles = articles.filter(element => articleStorage.includes(element.articleId));

  const onClick = id => {
    if (!id) return;

    const storage = JSON.parse(localStorage.getItem('likedExperiences'));
    if (storage.some(item => item === id)) {
      if (storage.indexOf(id) !== -1) {
        storage.splice(storage.indexOf(id), 1);

        localStorage.setItem('likedExperiences', JSON.stringify(storage));
      }
    } else {
      storage.push(id);

      localStorage.setItem('likedExperiences', JSON.stringify(storage));
    }
  };

  // TODO: To this, and delete local storage funcitonality at all

  return (
    <>
      <Header title="my jaaq" />
      {size < 992 && <Switcher data={switcherButtons} onClick={onSwitchClick} />}

      <StyledPageContainer>
        {size > 991 && (
          <StyledPageSidebar>
            <ExploreSidebar data={exploreSidebar} />
          </StyledPageSidebar>
        )}

        <StyledPageContent lighterBg={!state}>
          {state ? (
            <StyledPageMainContent>
              {size > 991 && <Switcher data={switcherButtons} onClick={onSwitchClick} />}
              {likedItemsToShow.length ? (
                <StoryList data={likedItemsToShow} heading={likedHeading} onClick={onClick} />
              ) : null}
              <LikedQuestions />
              <StoryList data={recommendedExperiences} heading={recommendedHeading} />
              <ArticleList articles={likedArticles} title="Saved feed" />
            </StyledPageMainContent>
          ) : (
            <StyledPageMainContent>
              {size > 991 && <Switcher data={switcherButtons} onClick={onSwitchClick} />}
              <Boards data={boards} />
            </StyledPageMainContent>
          )}
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default MyJaaq;
